import { useState, useRef } from "react";
import { X, Play } from "lucide-react";
import { motion, useScroll, useTransform } from "framer-motion";

const GALLERY_IMAGES = [
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/ipde32x3_Starbucks-container.jpg",
    alt: "Starbucks container drive-thru",
    categories: ["operators"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/orqz2c2d_kit-03.jpeg",
    alt: "Kitchen interior — prep stations and hood system",
    categories: ["interiors"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/cb6fz8z9_shipping-container-restaurant-.jpg",
    alt: "Container burger restaurant — #CreateYourTaste",
    categories: ["concepts"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/owalvvre_kitchen%20ext%20-02.jpg",
    alt: "White modular container unit exterior",
    categories: ["base-units"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/q1k78ddp_web1_copy_pork3dcontainer-mar19-14.jpg",
    alt: "Pork & Beans container restaurant at night",
    categories: ["operators"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/l0c9mdrc_kit%20ext%20-05.JPG",
    alt: "Branded modular kitchen unit — serving windows",
    categories: ["base-units"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/tlzx6ohv_Pappa%20Roti.jpg",
    alt: "PappaRoti container café with outdoor seating",
    categories: ["operators"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/w0udr331_Puma%20Pavillion.jpg",
    alt: "Puma Pavilion — multi-level container retail activation",
    categories: ["operators"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/2gm61wlj_kit%20-01.jpg",
    alt: "Kitchen interior — Vulcan cooking stations",
    categories: ["interiors"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/n1uzkasc_Chick%20Fil-a.jpg",
    alt: "Chick-fil-A modular container restaurant",
    categories: ["operators"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/bf6mncky_bin702_001-1024x683.jpg",
    alt: "Bin 702 container wine bar at night",
    categories: ["operators"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/504izgdd_Bar-Patio.jpg",
    alt: "Container bar and patio with rooftop deck",
    categories: ["operators"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/gizyux5m_2014-08-02_avanti_3.jpg",
    alt: "Avanti F&B container food hall at dusk",
    categories: ["concepts"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/vob9myon_b881784786z1_20190131171605_000gv21dg3aq2-0-1hbpvgvzj71kyk54qr2_ct1880x930.jpg",
    alt: "Multi-container coffee shop and showroom complex",
    categories: ["concepts"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/t4evcy1i_Bakery-4-.jpg",
    alt: "Black Box container bar with counter seating",
    categories: ["concepts"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/c8jfiflr_Coffee-shop-and-showroom-built-with-shipping-containers.jpg",
    alt: "IsoSpaces container café and showroom",
    categories: ["concepts"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/u0lxaf5g_Container%20Concepts%20Cafe%20Box%2020ft%20.jpg",
    alt: "Container Concepts Cafe Box 20ft unit",
    categories: ["concepts"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/68i2aoa5_container-coffee-shop-3d-model_0.jpg",
    alt: "Big Cup Coffee Club — container coffee shop",
    categories: ["concepts"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/676g229h_container-restaurant-imbiss.jpg",
    alt: "Imbiss modular restaurant — storefront concept",
    categories: ["concepts"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/jng4amxz_DESIGN%202.jpg",
    alt: "Multi-level container restaurant with rooftop deck",
    categories: ["concepts"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/v4tdhed1_fat_burger.png",
    alt: "Fatburger container restaurant with outdoor seating",
    categories: ["operators"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_turnkey-deploy/artifacts/mf651f7b_Full%20Service%20Restaurant.jpg",
    alt: "Full-service pop-up container restaurant with rooftop lounge",
    categories: ["concepts"],
  },
  {
    src: "https://customer-assets-4nw71qhi.emergentagent.net/job_turnkey-deploy/artifacts/ku8rb56p_Biscuit%20%281%29.png",
    alt: "Biscuits N Bagels — container breakfast café concept",
    categories: ["concepts"],
  },
  {
    src: "https://customer-assets-4nw71qhi.emergentagent.net/job_turnkey-deploy/artifacts/gixe9zz4_Shuckit.png",
    alt: "Shuck It — container oyster bar concept",
    categories: ["concepts"],
  },
  {
    src: "https://customer-assets-4nw71qhi.emergentagent.net/job_turnkey-deploy/artifacts/cf0a6zrz_Wangs%20%282%29.png",
    alt: "Wings N Thangs — container wing restaurant concept",
    categories: ["concepts"],
  },
  {
    src: "https://customer-assets-4nw71qhi.emergentagent.net/job_turnkey-deploy/artifacts/g059cdlf_hd-photo-1-40%20ft%20container%20-%20window%20wall-02.webp",
    alt: "40ft container interior — FRP walls, hub drain, epoxy floors",
    categories: ["base-units", "interiors"],
  },
  {
    src: "https://customer-assets-4nw71qhi.emergentagent.net/job_turnkey-deploy/artifacts/r4cbeg95_Labeled%2040ft%20container-03.png",
    alt: "40ft container kitchen cross-section — labeled infrastructure",
    categories: ["base-units", "interiors"],
  },
  {
    src: "https://customer-assets-4nw71qhi.emergentagent.net/job_turnkey-deploy/artifacts/0ob4mwry_hd-photo-1-40%20ft%20container%20hood%20wall.webp",
    alt: "40ft container kitchen — hood wall with grease trap and bathroom",
    categories: ["base-units", "interiors"],
  },
  {
    src: "https://customer-assets-4nw71qhi.emergentagent.net/job_turnkey-deploy/artifacts/h0n593bm_ChatGPT%20Image%20Sep%201%2C%202026%2C%2007_42_04%20PM.png",
    alt: "PadSite base unit — orange and black container kitchen with digital menu boards",
    categories: ["base-units"],
  },
  {
    src: "https://customer-assets-4nw71qhi.emergentagent.net/job_turnkey-deploy/artifacts/f8jezy24_ChatGPT%20Image%20Sep%201%2C%202026%2C%2007_49_15%20PM.png",
    alt: "PadSite base unit — all-black container kitchen with digital menu boards",
    categories: ["base-units"],
  },
  {
    src: "https://customer-assets-4nw71qhi.emergentagent.net/job_turnkey-deploy/artifacts/anc5cqzk_Modern%20Shipping%20Container%20Food%20Kiosk.png",
    alt: "PadSite base unit — white container kitchen with digital menu boards",
    categories: ["base-units"],
  },
  {
    src: "/images/about-vegan-burgler.webp",
    alt: "The Vegan Burgler — branded PadSite kitchen concept at Florida A&M University",
    categories: ["concepts"],
  },
  {
    src: "/images/about-oops-fingers.webp",
    alt: "Oops Where Are My Fingers — branded PadSite kitchen concept at Morehouse College",
    categories: ["concepts"],
  },
  {
    src: "/images/concept-bmas-house.webp",
    alt: "B'Mas House — homecooking concept PadSite kitchen serving a student queue",
    categories: ["concepts"],
  },
  {
    src: "/images/concept-menuboard-sunset.webp",
    alt: "Dual-window PadSite kitchen with digital menu boards glowing at sunset",
    categories: ["concepts"],
  },
  {
    src: "/images/concept-soul-rolls.webp",
    alt: "Soul Rolls — soul food and eggroll fusion concept PadSite kitchen with queue",
    categories: ["concepts"],
  },
  {
    src: "/images/concept-teppanyaki-night.webp",
    alt: "Teppanyaki concept — PadSite kitchen with live fire grill counter at night",
    categories: ["concepts"],
  },
  {
    src: "/images/concept-come-n-eat.webp",
    alt: "Come N Eat — hibachi soul food concept PadSite kitchen at dusk with live fire grill",
    categories: ["concepts"],
  },
  {
    src: "/images/concept-debs-doughnuts.webp",
    alt: "Deb's Doughnuts — pink container doughnut and coffee concept at Jackson Mall",
    categories: ["concepts"],
  },
  {
    src: "/images/open-famcourt.webp",
    alt: "FAMU Food Court — multi-level PadSite container food court with rooftop decks at dusk",
    categories: ["food-courts"],
  },
  {
    src: "/images/about-university-foodcourt.webp",
    alt: "University Food Court — PadSite container kitchens with rooftop decks and string lights",
    categories: ["food-courts"],
  },
  {
    src: "/images/food-court-stadium.webp",
    alt: "Stadium District food hall — multi-level white container village with rooftop decks and palm-lined streetscape",
    categories: ["food-courts"],
  },
  {
    src: "/images/food-court-courtyard.webp",
    alt: "Campus courtyard food court — The Vegan Burgler and Oops container kitchens with covered rooftop deck and stadium screen at dusk",
    categories: ["food-courts"],
  },
  {
    src: "/images/food-court-blkbox.webp",
    alt: "Three-story container food hall with stacked wooden decks and rooftop terrace",
    categories: ["food-courts"],
  },
  {
    src: "/images/food-court-night-1.webp",
    alt: "Night market food hall — mural-wrapped container kitchens, string lights, shade sails, and fire pit seating",
    categories: ["food-courts"],
  },
  {
    src: "/images/food-court-night-2.webp",
    alt: "Night market food hall — neon-signed container stalls and communal fire pits under string lights",
    categories: ["food-courts"],
  },
  {
    src: "/videos/food-court-stadium.mp4",
    webm: "/videos/food-court-stadium.webm",
    alt: "Stadium District food hall — video flythrough of the multi-level container village",
    categories: ["food-courts"],
    type: "video",
  },
  {
    src: "/videos/food-court-contained-1.mp4",
    webm: "/videos/food-court-contained-1.webm",
    alt: "CONTAINED food hall — video flythrough of the two-story container village with rooftop deck",
    categories: ["food-courts"],
    type: "video",
  },
  {
    src: "/videos/food-court-contained-2.mp4",
    webm: "/videos/food-court-contained-2.webm",
    alt: "CONTAINED food hall — video flythrough of the corner container build with balcony seating",
    categories: ["food-courts"],
    type: "video",
  },
];

// Shuffle once per page load so similar images don't sit next to each other in any filter group
const shuffled = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};
const SHUFFLED_IMAGES = shuffled(GALLERY_IMAGES);

const FILTERS = [
  { key: "base-units", label: "Base Units" },
  { key: "concepts", label: "Concepts" },
  { key: "food-courts", label: "Food Courts" },
  { key: "interiors", label: "Interiors" },
  { key: "operators", label: "Operators" },
  { key: "all", label: "All" },
];

export default function GalleryPage() {
  const [filter, setFilter] = useState("base-units");
  const [lightbox, setLightbox] = useState(null);
  const marqueeRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: marqueeRef, offset: ["start end", "end start"] });
  const xLeft = useTransform(scrollYProgress, [0, 1], ["-5%", "-25%"]);
  const xRight = useTransform(scrollYProgress, [0, 1], ["-25%", "-5%"]);
  const yFloat1 = useTransform(scrollYProgress, [0, 1], [60, -60]);
  const yFloat2 = useTransform(scrollYProgress, [0, 1], [-40, 40]);
  const textScale = useTransform(scrollYProgress, [0, 0.5, 1], [0.9, 1, 0.95]);
  const textOpacity = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [0.4, 1, 1, 0.4]);

  const topRow = SHUFFLED_IMAGES.filter(img => img.categories.includes("operators")).slice(0, 6);
  const bottomRow = SHUFFLED_IMAGES.filter(img => img.categories.includes("concepts")).slice(0, 6);

  const filtered = filter === "all" ? SHUFFLED_IMAGES : SHUFFLED_IMAGES.filter((img) => img.categories.includes(filter));

  return (
    <div>
      {/* Hero */}
      <section style={{ backgroundColor: "#2d2d2d" }}>
        <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-24 pt-28 pb-14 md:py-20">
          <p
            className="text-xs uppercase tracking-[0.25em] font-semibold mb-6 opacity-0 animate-fade-up"
            style={{ color: "#d4782f" }}
          >
            Portfolio
          </p>
          <h1
            className="text-3xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.08] mb-6 opacity-0 animate-fade-up animate-delay-1"
            style={{ color: "#FFFFFF", fontFamily: "'Space Grotesk', sans-serif" }}
          >
            The PadSite Gallery
          </h1>
          <p
            className="text-base md:text-lg leading-relaxed max-w-2xl opacity-0 animate-fade-up animate-delay-2"
            style={{ color: "rgba(255,255,255,0.75)" }}
          >
            Modular restaurant units, commercial kitchen interiors, and
            real-world operator deployments from around the world.
          </p>
        </div>
      </section>

      {/* Scroll-Driven Image Marquee with Phrase */}
      <section ref={marqueeRef} className="relative overflow-hidden" style={{ backgroundColor: "#FAFAFA", paddingTop: "44px", paddingBottom: "44px" }}>
        {/* Top row - scrolls left on scroll */}
        <motion.div style={{ x: xLeft }} className="flex gap-4 mb-4 whitespace-nowrap">
          {[...topRow, ...topRow, ...topRow].map((img, i) => (
            <motion.div key={`top-${i}`} style={{ y: i % 2 === 0 ? yFloat1 : 0 }} className="flex-shrink-0 w-56 md:w-72 h-36 md:h-48 overflow-hidden group">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
            </motion.div>
          ))}
        </motion.div>

        {/* Center phrase - scales and fades with scroll */}
        <motion.div style={{ scale: textScale, opacity: textOpacity }} className="relative z-10 text-center py-8 md:py-10">
          <h2 className="text-3xl md:text-5xl lg:text-7xl font-bold tracking-tighter" style={{ fontFamily: "'Space Grotesk', sans-serif", color: "#1A1D23" }}>
            Built for <span style={{ color: "#d4782f" }}>Every Concept.</span>
          </h2>
          <p className="text-sm md:text-base mt-4" style={{ color: "#4A4F5C" }}>
            From QSR drive-thrus to craft cocktail bars — one modular platform, infinite possibilities.
          </p>
        </motion.div>

        {/* Bottom row - scrolls right on scroll */}
        <motion.div style={{ x: xRight }} className="flex gap-4 mt-4 whitespace-nowrap">
          {[...bottomRow, ...bottomRow, ...bottomRow].map((img, i) => (
            <motion.div key={`bot-${i}`} style={{ y: i % 2 === 0 ? yFloat2 : 0 }} className="flex-shrink-0 w-56 md:w-72 h-36 md:h-48 overflow-hidden group">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
            </motion.div>
          ))}
        </motion.div>
      </section>

      {/* Gallery Grid */}
      <section style={{ backgroundColor: "#F4F5F7" }}>
        <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-24 py-10 md:py-16">
          {/* Filters */}
          <div className="flex flex-wrap gap-3 mb-10">
            {FILTERS.map((f) => (
              <button
                key={f.key}
                data-testid={`gallery-filter-${f.key}`}
                onClick={() => setFilter(f.key)}
                className="px-5 py-3 min-h-[44px] inline-flex items-center text-xs uppercase tracking-[0.15em] font-semibold transition-colors rounded-none"
                style={{
                  backgroundColor: filter === f.key ? "#d4782f" : "transparent",
                  color: filter === f.key ? "#FFFFFF" : "#3A3A3A",
                  border: `1px solid ${filter === f.key ? "#d4782f" : "rgba(58,58,58,0.3)"}`,
                }}
              >
                {f.label}
              </button>
            ))}
          </div>

          {/* Masonry-style Grid */}
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4">
            {filtered.map((img, i) => (
              <div
                key={i}
                className="mb-4 break-inside-avoid cursor-pointer group relative overflow-hidden"
                onClick={() => setLightbox(img)}
                data-testid={`gallery-image-${i}`}
              >
                {img.type === "video" ? (
                  <video
                    muted
                    loop
                    autoPlay
                    playsInline
                    className="w-full h-auto transition-transform duration-500 group-hover:scale-105"
                  >
                    <source src={img.src} type="video/mp4" />
                    {img.webm && <source src={img.webm} type="video/webm" />}
                  </video>
                ) : (
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-auto transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                )}
                {img.type === "video" && (
                  <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full" style={{ backgroundColor: "rgba(45,45,45,0.85)" }}>
                    <Play size={13} color="#d4782f" fill="#d4782f" />
                  </div>
                )}
                {/* Hover overlay */}
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end"
                  style={{ background: "linear-gradient(transparent 50%, rgba(4,19,26,0.8) 100%)" }}
                >
                  <p className="p-5 text-sm font-medium" style={{ color: "#FFFFFF" }}>
                    {img.alt}
                  </p>
                </div>
                {/* Bottom accent */}
                <div
                  className="absolute bottom-0 left-0 right-0 h-0.5 opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{ backgroundColor: "#d4782f" }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ backgroundColor: "rgba(0,0,0,0.9)" }}
          onClick={() => setLightbox(null)}
          data-testid="gallery-lightbox"
        >
          <button
            className="absolute top-4 right-4 z-10 p-3"
            onClick={() => setLightbox(null)}
            data-testid="lightbox-close"
            aria-label="Close"
          >
            <X size={32} style={{ color: "#FFFFFF" }} />
          </button>
          {lightbox.type === "video" ? (
            <video
              controls
              autoPlay
              playsInline
              loop
              className="max-w-full max-h-[85vh]"
              onClick={(e) => e.stopPropagation()}
              data-testid="lightbox-video"
            >
              <source src={lightbox.src} type="video/mp4" />
              {lightbox.webm && <source src={lightbox.webm} type="video/webm" />}
            </video>
          ) : (
            <img
              src={lightbox.src}
              alt={lightbox.alt}
              className="max-w-full max-h-[85vh] object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          )}
          <p
            className="absolute bottom-24 md:bottom-20 left-1/2 -translate-x-1/2 text-sm text-center max-w-lg"
            style={{ color: "rgba(255,255,255,0.7)" }}
          >
            {lightbox.alt}
          </p>
        </div>
      )}
    </div>
  );
}
